import { useEffect, useRef, useState } from "react";

import { ChevronDown } from "../../../../assets/icons/ChevronDown";
import { OptionButton, OptionsBar } from "../../../../components/OptionsBar";
import { RadioButton } from "../../../../components/RadioButton";
import {
  FilterContainer,
  RadioButtonContainer,
  RadioGroupContainer,
} from "../MeasurementModal/components/CustomOptionsBar/CustomOptionsBar.styles";
import { ControlWrapper } from "./EcgControlSelect.styles";

export type EcgControlSelectProps = {
  label: string;
  value: number;
  suffix: string;
  options: readonly number[];
  onChange: (value: number) => void;
};

// A filter-style control: the OptionButton (reused from the other graphs) opens
// the same filter popover (FilterContainer + RadioButton) used on those graphs.
export function EcgControlSelect({
  label,
  value,
  suffix,
  options,
  onChange,
}: EcgControlSelectProps) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <ControlWrapper ref={wrapperRef}>
      <OptionsBar borderRadius="16px">
        <OptionButton
          text={`${label}: ${value}${suffix}`}
          icon={<ChevronDown />}
          iconPosition="Right"
          backgroundColor="var(--colors-measurement-modal-filter-button-active-background)"
          color="var(--colors-measurement-modal-filter-button-active-text)"
          hoverBackgroundColor="var(--colors-measurement-modal-filter-button-active-hover-background)"
          borderRadius="16px"
          letterSpacing="0.1px"
          padding="2px 12px"
          onClick={() => setOpen((prev) => !prev)}
        />
      </OptionsBar>

      {open && (
        <FilterContainer
          css={{ top: "calc(100% + 6px)", left: 0, right: "auto" }}
        >
          <RadioGroupContainer>
            <b>{label}</b>
            {options.map((option) => (
              <RadioButtonContainer key={option}>
                <p>{`${option}${suffix}`}</p>
                <RadioButton
                  checked={option === value}
                  onClick={() => {
                    onChange(option);
                    setOpen(false);
                  }}
                />
              </RadioButtonContainer>
            ))}
          </RadioGroupContainer>
        </FilterContainer>
      )}
    </ControlWrapper>
  );
}
